import { FC, useCallback } from "react";
import styles from "./HorizontalHandle.module.scss";
import { useDrag } from "../lib/drag";
import { Offset } from "../model/offset";

interface Props {
  zoom: number;
  onDragStart?: () => void;
  onDragMove?: (offset: Offset) => void;
  onDragEnd?: () => void;
}

export const HorizontalHandle: FC<Props> = (props) => {
  const { onDragMove } = props;

  const handleDragMove = useCallback(
    (offset: Offset) => {
      onDragMove?.({
        deltaX: 0,
        deltaY: offset.deltaY / props.zoom,
      });
    },
    [onDragMove, props.zoom],
  );

  const handleMouseDown = useDrag({
    onDragStart: props.onDragStart,
    onDragMove: handleDragMove,
    onDragEnd: props.onDragEnd,
  });

  return <div className={styles.container} onMouseDown={handleMouseDown} />;
};
